export default __webpack_public_path__ + "static/media/resume.5f98ba53.pdf";